//
//  DocumentationLegacyPageBlockTokenGroup.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockTokenGroup extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        super(model, children);
        this.groupId = model.designObjectId;
        this.showNestedGroups = model.showNestedGroups;
    }
}
